if (!customElements.get('estimated-delivery')) {
	customElements.define(
		'estimated-delivery',
		class extends HTMLElement {
			connectedCallback() {
				const configEl = this.querySelector('script[data-ed-config]');
				this.container = this.querySelector('[data-ed-blocks]');

				if (!configEl || !this.container) return;

				this.config = JSON.parse(configEl.textContent);
				this.form = this.closest('form') || document.getElementById(this.getAttribute('form-id'));

				if (!this.form) return;

				this.onVariantChange = this.#onVariantChange.bind(this);
				this.form.addEventListener('variant:change', this.onVariantChange);
			}

			disconnectedCallback() {
				this.form?.removeEventListener('variant:change', this.onVariantChange);
			}

			#onVariantChange(event) {
				const variant = event.detail.variant;
				if (!variant) return;

				const data = this.config.variants[variant.id];
				if (!data) return;

				this.container.innerHTML = this.#render(data);
			}

			#render(data) {
				const blocks = [];
				const fastStock = data.house + data.nod;

				if (data.priorityDate && data.furnizor > 0) {
					blocks.push(this.#block('furnizor', this.#furnizorText(data.furnizor, data.supplierDate)));
					return blocks.join('');
				}

				if (fastStock > 0) {
					blocks.push(this.#block('stoc', `${fastStock} buc în stoc. Livrare în 1-2 zile`));
				}

				if (data.furnizor > 0) {
					blocks.push(this.#block('furnizor', this.#furnizorText(data.furnizor, data.supplierDate)));
				}

				if (blocks.length === 0) {
					if (data.available && data.supplierDate) {
						blocks.push(this.#block('furnizor', `Disponibil de la ${data.supplierDate}`));
					} else {
						blocks.push(
							data.available ? this.#block('stoc', 'În stoc.') : this.#block('furnizor', 'Indisponibil'),
						);
					}
				}

				return blocks.join('');
			}

			#furnizorText(furnizor, supplierDate) {
				if (supplierDate) {
					const availability = furnizor > 1 ? 'bucati disponibile' : 'bucată disponibilă';

					return `${furnizor} ${availability} de la ${supplierDate}`;
				}

				return `${furnizor} buc în stoc furnizor`;
			}

			#block(type, text) {
				return `<div class="livrare-dropshipping">
        <div class="store--icon store--icon__${type}">
          <span style="color: #fff">${this.config.icon}</span>
        </div>
        <h4>${text}</h4>
      </div>`;
			}
		},
	);
}
